import React, {Component, Fragment} from 'react';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import {toggleModalMapUserDataUpdate} from '../../../../actions/ModalActions';
import Dialog from '@material-ui/core/Dialog';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import './UserDataUpdateModalMapDialog.css';
import MapWithASearchBox from '../../../Map/MapWithSearchBox';
import {ALT_ICON, BACK_TO_EVENT_FORM, SAVE_AND_CONTINUE_IN_EVENT_CREATION, CHOOSE_LOCATION_OF_EVENT,
    MODAL_MAP_INTRO_TEXT} from '../../../../config/TextContent';
import SearchBoxInput from '../../../Map/SearchboxInput/SearchboxInput';
import { withScriptjs } from 'react-google-maps';
import {GOOGLE_MAP_URL} from '../../../../config/Constants';

class UserDataUpdateModalMapDialog extends Component {
    
    SearchBox =  withScriptjs(() =>{
        return ( 
            <SearchBoxInput 
                place={this.props.place}
                onSelectAddressChange={this.props.onSelectAddressChange}
                onSelectAddressComponents={this.props.onSelectAddressComponents}
            />
        );
    });

    render() {
        return (
            <Dialog
                fullScreen={true}
                fullWidth={true}
                scroll='body'
                open={this.props.userDataUpdateMapModal}
                className='event-modal-map-dialog'
                onClose={() => this.props.toggleModalMapUserDataUpdate(false, true)}
            >
                <Button onClick={() => this.props.toggleModalMapUserDataUpdate(false, true)} className="event-modal-map-dialog__close-button">
                    <img src={'/img/icons/arrow-pointing-to-right.svg'} alt={ALT_ICON}/>
                    {BACK_TO_EVENT_FORM}
                </Button>
                <div className="row">
                    <div className="col-md-6 event-modal-map-dialog__left-side-wrapper">
                        <div className="row">
                            <div className="col-md-1 event-modal-map-dialog__left-side-wrapper__img-number">
                                <img src={'/img/icons/numbers/'+ this.props.step +'.svg'} alt={ALT_ICON}/>
                            </div>
                            <div className="col-md-11 col-xs-12 event-modal-map-dialog__left-side-wrapper__location">
                                <p>{CHOOSE_LOCATION_OF_EVENT}</p>                                         
                            </div>
                        </div>
                        <div className="row event-modal-map-dialog__left-side-wrapper__intro-title">
                            <div className="col-md-10 col-md-offset-1 col-xs-12">
                                <div className="event-modal-map-dialog__left-side-wrapper__intro-title">
                                    <p>{MODAL_MAP_INTRO_TEXT}</p>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-offset-1 col-md-10 col-xs-12">
                                <div className="event-modal-map-dialog__left-side-wrapper__concrete-place">
                                    <div className="row event-modal-map-dialog__left-side-wrapper__concrete-place-wrapper">
                                        <div className="col-md-12">
                                            <Fragment>
                                                <this.SearchBox 
                                                    googleMapURL={GOOGLE_MAP_URL}
                                                    loadingElement={<div></div>}
                                                    containerElement={<div className="map-container-element-height" />}
                                                    onChange={this.props.onChange}
                                                />
                                            </Fragment>
                                            <p className="event-modal-map-dialog__left-side-wrapper__concrete-place-title">
                                                <span className="event-modal-map-dialog__left-side-wrapper__concrete-place"> {this.props.place}</span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 text-align-center">
                                            <button className="default_transparent_button" onClick={() => this.props.toggleModalMapUserDataUpdate(false, true)}>
                                                { SAVE_AND_CONTINUE_IN_EVENT_CREATION }                                        
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 no-padding-right">
                        <MapWithASearchBox 
                            onSelectAddressComponents={this.props.onSelectAddressComponents}
                            onSelectAddressChange={this.props.onSelectAddressChange}
                            markerPositionChanged={this.props.markerPositionChanged}
                            markerLatLng={this.props.markerLatLng}
                            centerLatLng={this.props.centerLatLng}
                        />            
                    </div>
                </div>
            </Dialog>
        )
    }
}

UserDataUpdateModalMapDialog.propTypes = {
    userDataUpdateMapModal: PropTypes.bool.isRequired,
    onSelectAddressChange: PropTypes.func.isRequired,
    onSelectAddressComponents: PropTypes.func.isRequired
}

const mapStateToProps = (state) => {
    return {
        userDataUpdateMapModal: state.modalReducer.userDataUpdateMapModal,
    }
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        toggleModalMapUserDataUpdate,
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(UserDataUpdateModalMapDialog);
